import React, { useRef } from 'react'
import { YDivider, XDivider, useTheme, makeStyles } from 'irmlib/styles'
import styled from 'styled-components'
// import Table from '../../../Controls/Table'
import MuiDataTable from '../../../Controls/MuiDataTable'
import { Link, useHistory } from 'react-router-dom'
import { ContainedButton, Label, MenuButton, OutlinedButton, CheckBox } from 'irmlib/components/Controls'
import * as routePaths from '../../../../navigation/routePaths'
import * as gdeTransactionsLite from '../../../../services/firestore/gdeTransactionsLite'
import PropTypes from 'prop-types'
import moment from 'moment'
import { MoreVert } from 'irmlib/icons'
import { clearBusy, setBusy, closeGeneralDialog, openGeneralDialog } from '../../../../irmlib/src/containers'
import { defaultDateFormat } from '../../../../common/constants'
import * as constants from 'irmlib/common/constants'
import { today, getMonth } from '../../../../irmlib/src/common'
import { totalNoOfBoxesForJob } from '../../../../services/common/appConstants'
import { DateTime } from '../../../../irmlib/src/components/FormControls'
import { Grid, Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import TopButtons from './TopButtons'

const BottomPaddedDiv = styled('div')`
  padding-bottom: 20px;
`

const TableContainer = styled(BottomPaddedDiv)`
`

const JobLink = styled(Link)`
  color: ${props => props.theme.palette.primary.main};
  text-decoration: none;
`

const minWidth = '100px'

const useStyles = makeStyles({
  disabledState: {
    pointerEvents: 'none',
    opacity: '0.4'
  },
  startButton: {
    textDecoration: 'none'
  }
})

const ClosedJobData = (props) => {
  const { t } = useTranslation()
  const value = props.filterData
  const classes = useStyles()
  const theme = useTheme()
  // const [refresh, setRefresh] = React.useState(false)
  // const [Alldata, setData] = React.useState([])
  const [selectedData, setSelectedData] = React.useState({})
  // Here, useRef is used instead of useState to prevent unwanted rerendering.
  const Alldata = useRef([])

  const updateState = (newValue) => {
    Alldata.current = newValue
  }

  const history = useHistory()

  const showUsers = (obj) => {
    const names = []
    for (const key in obj) {
      if (obj[key].workerName !== undefined && obj[key].jobCategory.includes('Data Entry User')) {
        names.push(obj[key].workerName)
      }
    }
    return names.join(',')
  }

  const dataRet = async (val) => {
    const dataQuery = async (val) => {
      setBusy()
      const coll = await gdeTransactionsLite.getQueryDataJob2(val)
      const val3 = []
      coll.forEach((doc) => {
        if (val.createDateFrom !== constants.defaultSelect || val.createDateTo !== constants.defaultSelect || val.userName !== '--Select--') {
          const docData = doc.data()
          const assignedUserList = docData?.assignedUserList
          let isValid = true
          const createDateJob = moment(docData.createdTs.seconds, 'X').format(defaultDateFormat)
          const createDateFromFilter = moment(val.createDateFrom).format(defaultDateFormat)
          const createDateToFilter = moment(val.createDateTo).format(defaultDateFormat)
          const convtCreateDateJob = new Date(createDateJob).getTime()
          const convtCreateDateFrom = new Date(createDateFromFilter).getTime()
          const convtCreateDateTo = new Date(createDateToFilter).getTime()
          if (val.createDateFrom !== constants.defaultSelect && val.createDateTo !== constants.defaultSelect) {
            if (convtCreateDateFrom > convtCreateDateJob || convtCreateDateTo < convtCreateDateJob) {
              isValid = false
            }
          } else if (val.createDateFrom !== constants.defaultSelect) {
            if (convtCreateDateFrom > convtCreateDateJob) {
              isValid = false
            }
          } else if (val.createDateTo !== constants.defaultSelect) {
            if (convtCreateDateTo < convtCreateDateJob) {
              isValid = false
            }
          }

          if (val.userName !== '--Select--') {
            if (assignedUserList !== undefined) {
              if (!assignedUserList.includes(val.userName)) {
                isValid = false
              } 
            } else if (assignedUserList === undefined) {
              isValid = false
            }
          }

          if (isValid) {
            pushData(doc, val3)
          }
        } else {
          pushData(doc, val3)
        }
      })
      updateState(val3)
      clearBusy()
      return val3
    }
    return await dataQuery(val)
  }

  const pushData = (doc, val) => {
    let totalNoOfBoxes = 0
    if (doc.data().totalBoxes === totalNoOfBoxesForJob) {
      totalNoOfBoxes = '-'
    } else {
      totalNoOfBoxes = parseInt(doc.data().totalBoxes)
    }

    val.push({
      jobId: doc.id,
      status: doc.data().jobStatus,
      status1: doc.data().jobStatus,
      boxes: totalNoOfBoxes,
      dateCreated: doc.data().createdTs ? moment(doc.data().createdTs.seconds, 'X').format('YYYY-MM-DD') : '0000-00-00',
      dataEntryUser: doc?.data()?.workerName?.join(', ') || showUsers(doc?.data()?.assignedUsers),
      boxesCompleted: doc.data().boxesCompleted ? doc.data().boxesCompleted : 0,
      targetDate: doc.data().targetDate ? moment(doc.data().targetDate.seconds, 'X').format('YYYY-MM-DD') : '0000-00-00',
      autoTransmit: (doc.data().autoTransmit === undefined) ? 'true' : doc.data().autoTransmit,
      manualTransmit: (doc.data().autoTransmit === undefined) ? 'false' : (doc.data().autoTransmit === 'true') ? 'false' : 'true',
      orderNumber: doc.data().orderNumber,
      jobType: doc.data().dataEntryType,
      jobType1: doc.data().dataEntryType
    })
  }

  const handleCalcelDeleteBox = () => {
    closeGeneralDialog()
  }

  const handleCopyJob = async (jobId) => {
    history.push(`${routePaths.createJob}/${jobId}`)
    closeGeneralDialog()
  }

  const ContentForCopyJob = (props) => (
    <>
      <Label id={'allJobs_deleteButton_deleteContent1'} >Search.copyJobContentMessage</Label>
      <VerticalDivider />
    </>
  )
  const DeleteBox = (props) => (
    <>
      <VerticalDivider />
      <XDivider width="25px" />
      <OutlinedButton id={'allJobs_deleteButton_cancel'}noTranslate style={{ minWidth }} onClick={props.handleCancel} >Search.Cancel</OutlinedButton>
      <ContainedButton id={'allJobs_deleteButton_yes'} style={{ minWidth }} onClick={props.handleDelete}>Search.yes</ContainedButton>
      <VerticalDivider />
      <XDivider width="25px" />
    </>
  )

  const CopyJob = (props) => (
    <>
      <VerticalDivider />
      <XDivider width="25px" />
      <OutlinedButton id={'allJobs_deleteButton_cancel'} style={{ minWidth }} onClick={props.handleCancel} >Search.Cancel</OutlinedButton>
      <ContainedButton id={'allJobs_deleteButton_yes'} style={{ minWidth }} onClick={props.handleCopyJob}>Search.yes</ContainedButton>
      <VerticalDivider />
      <XDivider width="25px" />
    </>
  )

  const CancelBox = (props) => (
    <>
      <VerticalDivider />
      <XDivider width="25px" />
      <OutlinedButton id={'allJobs_deleteButton_cancel'} style={{ minWidth }} onClick={props.handleCancel} >Search.Cancel</OutlinedButton>
      <ContainedButton id={'allJobs_deleteButton_yes'} style={{ minWidth }} onClick={props.handleDelete}>Search.yes</ContainedButton>
      <VerticalDivider />
      <XDivider width="25px" />
    </>
  )
  CopyJob.propTypes = {
    handleCancel: PropTypes.func,
    handleCopyJob: PropTypes.func
  }
  DeleteBox.propTypes = {
    handleCancel: PropTypes.func,
    handleDelete: PropTypes.func
  }
  CancelBox.propTypes = {
    handleCancel: PropTypes.func,
    handleDelete: PropTypes.func
  }

  // const getPageData = async (page, pageSize) => {
  //   return await uiGet({ service: () => dataRet(value) })
  // }
  const getPageData = async (page, pageSize) => {
    try {
      const data = await dataRet(value)
      return data
    } catch (error) {
      // eslint-disable-next-line
      console.error('Error fetching page data:', error)
      return []
    }
  }


  const openCopyJobDialog = (jobId) => {
    openGeneralDialog({
      title: t('Search.CopyJob'),
      noTranslateTitle: true,
      message: <ContentForCopyJob />,
      closeX: true,
      buttons: (
        <CopyJob
          handleCancel={handleCalcelDeleteBox}
          handleCopyJob={() => handleCopyJob(jobId)}
        />
      )
    })
    return Promise.resolve()
  }

  const onSelect = (value, rowdata) => {
    if (value === 'CopyJob') {
      openCopyJobDialog(rowdata.jobId)
    } 
  }

  const columns = [
    { 
      label: t('tableColumns.jobId'), 
      name: 'jobId',
      options: {
        customBodyRenderLite: (dataIndex) => {
          const rowdata = Alldata.current[dataIndex]
          return (
            <JobLink id={`allJobs_jobLink_${rowdata?.jobId}`} className={rowdata?.status1 === constants.jobStatus.cancel ? classes.disabledState : null} theme={theme} to={{ pathname: `${routePaths.boxList}/${rowdata?.jobId}`, state: { fromAdmin: true } }}>
              {rowdata?.jobId}
            </JobLink>
          )
        },
        filter: false,
      } 
    }, 
    { 
      label: t('tableColumns.status'), 
      name: 'status', 
      options: {
        filterType: 'multiselect',
      }
    }, 
    { 
      label: t('tableColumns.dateCreated'),
      name: 'dateCreated',
      options: {
        filterType: 'custom',
        filterOptions: {
          display: (filterList, onChange, index, column) => (
            <DateTime
              label= {t('tableColumns.dateCreated')}
              type='month'
              minDate={getMonth('2020-01')}
              maxDate= {getMonth(today())}
              onChange={(selectedMonth) => {
                const updatedFilterList = [...filterList]
                updatedFilterList[index] = selectedMonth ? [selectedMonth] : []
                onChange(updatedFilterList[index], index, column)
              }}
            />
          ),
          logic: (rowData, filterValue) => {
            if (filterValue && filterValue.length) {
              const filterMonth = filterValue[0]
              return !rowData.includes(filterMonth)
            } else {
              return false
            }
          }
        },
      },
    }, 
    { 
      label: t('tableColumns.dataEntryUser'),
      name: 'dataEntryUser'
    },
    { 
      label: t('tableColumns.boxes'), 
      name: 'boxes',
      options: {
        filter: false
      }
    },
    { 
      label: t('tableColumns.boxesTransmitted'), 
      name: 'boxesCompleted',
      options: {
        filter: false
      }
    },
    { 
      label: t('tableColumns.targetCompletionDate'), 
      name: 'targetDate',
      options: {
        filter: false
      }
    },
    { 
      label: t('tableColumns.manualTransmit'), 
      name: 'manualTransmit',
      options: {
        filterType: 'dropdown',
        filterOptions: {
          names: [t('Search.Yes'), t('Search.No')],
          logic: (rowData, filterValue) => {
            if (filterValue[0] === t('Search.Yes')) {
              return rowData !== 'true'
            } else if (filterValue[0] === t('Search.No')) {
              return rowData !== 'false'
            } else {
              return false
            }
          }
        },
        customBodyRenderLite: (dataIndex) => {
          return (
            <CheckBox disabled checked={(Alldata.current[dataIndex]?.manualTransmit === 'true')} />
          )
        }
      },
    },
    { 
      label: t('tableColumns.orderNumber'), 
      name: 'orderNumber',
      options: {
        filterType: 'textField',
      }
    },
    { 
      label: t('tableColumns.type'), 
      name: 'jobType'
    },
    {
      name: 'modify',
      label: t('tableColumns.action'),
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <MenuButton
              id={'allJobs_ellipsis'}
              buttonIcon={<MoreVert />}
              rowdata={Alldata.current[dataIndex]}
              items={menuItems}
              onSelect={(value) => { onSelect(value, Alldata.current[dataIndex]) }}
            />
          )
        }
      }
    }
  ]

  const menuItems = [
    { value: 'CopyJob', label: t('Search.CopyJob'), style: { color: theme.palette.primary.main } },
  ]

  const VerticalDivider = () =>
    <YDivider height='25px' />

  const options = {
    filterType: 'dropdown',
    selectableRows: 'single',
    selectToolbarPlacement: 'none',
    elevation: 0,
    page: 0,
    onRowSelectionChange: (currentRowsSelected, allRowsSelected) => {
      if (allRowsSelected.length === 0) {
        setSelectedData({})
        return
      }
      const currentRowIndex = currentRowsSelected[0].dataIndex
      setSelectedData(Alldata.current[currentRowIndex])
    },
    customRowOptions: (rowData, rowMeta) => {
      return (
        <MenuButton
          id={'allJobs_ellipsis'}
          buttonIcon={<MoreVert />}
          rowData={rowData}
          items={menuItems}
          onSelect={(value) => { onSelect(value, rowData) }}
        />
      )
    },
  }
  return (
    <>
      <TableContainer>
        <Box boxShadow={3} borderRadius={4}>
          <Grid item container xs={12} md={12} sx={{ padding: '20px 20px 0px' }}>
            <Grid item container xs={12} md={4} alignItems={'center'}>
              <Typography variant='h6'>
                {t('routeTitles.closedJobs')}
              </Typography>
            </Grid>
            <Grid item container xs={12} md={8} justifyContent="end">
              <TopButtons selectedData={selectedData} id={'AllJobs_topButtons'} />
            </Grid>
          </Grid>
          <MuiDataTable
            prop={props}
            data={getPageData}
            columns={columns}
            options={options}
      />
        </Box>
      </TableContainer>
    </>
  )
}
ClosedJobData.propTypes = {
  filterData: PropTypes.object,
}

export default ClosedJobData